































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import '@/compiled-icons/add';
import '@/compiled-icons/drag-horizontal-variant';
import '@/compiled-icons/delete';
import '@/compiled-icons/format-underline';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import DynamicDocumentNumberBrickTemplate from '../bricks/dynamic-document-number-brick-template.vue';
import DynamicDocumentDateBrickTemplate from '../bricks/dynamic-document-date-brick-template.vue';
import DynamicDocumentSignatureBrickTemplate from '../bricks/dynamic-document-signature-brick-template.vue';
import DynamicDocumentTextFieldTemplate from '../fields/dynamic-document-text-field-template.vue';
import DynamicDocumentDateFieldTemplate from '../fields/dynamic-document-date-field-template.vue';
import DynamicDocumentCheckboxFieldTemplate from '../fields/dynamic-document-checkbox-field-template.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';
import AmetrasResponsiveTabBar from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
import AdvancedConfirmDialog, {ConfirmationDialogConfig} from '@/views/AdvancedConfirmDialog.vue';
import DynamicDocumentNumberFieldTemplate from '@/views/dynamicdocuments/fields/dynamic-document-number-field-template.vue';
import DynamicDocumentRowsDesignerTemplate, {
  RowDesignerContentTypes
} from '@/views/dynamicdocuments/dynamic-document-rows-designer-template.vue';
import DynamicDocumentYearMonthFieldTemplate from '@/views/dynamicdocuments/fields/dynamic-document-year-month-field-template.vue';
import DynamicDocumentSignatureFieldTemplate from '@/views/dynamicdocuments/fields/dynamic-document-signature-field-template.vue';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';
import DynamicDocumentFontConfigurationTemplate from '@/views/dynamicdocuments/fields/dynamic-document-font-configuration-template.vue';

interface ContentDialogButton<T extends DisguiseDto.DynamicDocumentFieldTypeDtoV2Union> {
  onClick: (event: Event,
            button: ContentDialogButton<T>,
            content: T) => void;
  loading: boolean;
  disabled: boolean;
  title: string;
  text: string;
}

interface ContentDialog<T extends DisguiseDto.DynamicDocumentFieldTypeDtoV2Union> {
  buttons?: Array<ContentDialogButton<T>>;
  content?: T;
  onClose?: () => void;
  title?: string;
}

@Component({
  name: 'dynamic-document-list-table-brick-template',
  components: {
    DynamicDocumentFontConfigurationTemplate,
    AmetrasHexColorPickerTemplate,
    DynamicDocumentSignatureFieldTemplate,
    DynamicDocumentYearMonthFieldTemplate,
    DynamicDocumentRowsDesignerTemplate,
    AdvancedConfirmDialog,
    DynamicDocumentNumberFieldTemplate,
    AmetrasResponsiveTabBar,
    DynamicDocumentScreenWidthConfigurationTemplate,
    AmetrasDateFieldTemplate,
    DynamicDocumentCheckboxFieldTemplate,
    DynamicDocumentDateFieldTemplate,
    DynamicDocumentTextFieldTemplate,
    DynamicDocumentSignatureBrickTemplate,
    DynamicDocumentDateBrickTemplate,
    DynamicDocumentNumberBrickTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasTextFieldTemplate,
    AmetrasSelectFieldTemplate,
    draggable,
  }
})
export default class DynamicDocumentListTableBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldDtoV2 | undefined;

  splitSizes: DisguiseDto.SelectDto[] = [{
    text: '',
    value: ''
  }, {
    text: 'Gesamtbreite',
    value: '1'
  }, {
    text: 'halbe Breite',
    value: '2'
  }, {
    text: 'drittel Breite',
    value: '3'
  }];
  widthPercentageSelectOptions!: DisguiseDto.SelectDto[];
  supportedCellContentTypes: Set<RowDesignerContentTypes> = new Set([
    'DynamicDocumentFieldTypeTextDto',
    'DynamicDocumentFieldTypeNumberDto',
    'DynamicDocumentFieldTypeCheckboxDto',
    'DynamicDocumentFieldTypeDateDto',
    'DynamicDocumentFieldTypeYearMonthDto',
    'DynamicDocumentFieldTypeSignatureDto'
  ]);

  tabIndex: number = 0;

  showContentDialog: boolean = false;
  contentDialog: ContentDialog<any> = {};
  showConfirmationDialog: boolean = false;
  confirmationDialogConfig: ConfirmationDialogConfig | undefined;

  created() {
    const allWidths: DisguiseDto.SelectDto[] = [{
      text: 'auto',
      value: ''
    }];

    for (let percentageCounter = 1; percentageCounter <= 100; percentageCounter++) {
      allWidths.push({
        text: `${percentageCounter}%`,
        value: `${percentageCounter}`
      });
    }

    this.widthPercentageSelectOptions = allWidths;
  }

  addSection() {
    if (this.fieldConfig) {
      const castedFieldType = this.fieldConfig.fieldType as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2;
      if (!castedFieldType.sections) {
        castedFieldType.sections = [];
      }
      castedFieldType.sections.push({
        '@type': 'DynamicDocumentListTableSectionDtoV2',
        'label': 'neue Sektion',
        'rows': []
      });
    }
  }

  addSectionRow(section: DisguiseDto.DynamicDocumentListTableSectionDtoV2) {
    const cells: DisguiseDto.DynamicDocumentListTableSectionRowCellDtoV2[] = [];

    if (this.fieldConfig) {
      const castedTableFieldType = this.fieldConfig.fieldType as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2;
      for (const currentColumn of castedTableFieldType.columns || []) {
        let castedFieldType: DisguiseDto.DynamicDocumentFieldTypeDtoV2Union | undefined;
        if (currentColumn.fieldType) {
          switch (currentColumn.fieldType['@type']) {
            case 'DynamicDocumentFieldTypeDateDtoV2': {
              castedFieldType = {
                ...currentColumn.fieldType as DisguiseDto.DynamicDocumentFieldTypeDateDtoV2,
                label: '',
                value: ''
              };
              break;
            }
            case 'DynamicDocumentFieldTypeNumberDtoV2': {
              castedFieldType = {
                ...currentColumn.fieldType as DisguiseDto.DynamicDocumentFieldTypeNumberDtoV2,
                label: '',
                value: 0
              };
              break;
            }
            case 'DynamicDocumentFieldTypeTextDtoV2': {
              castedFieldType = {
                ...currentColumn.fieldType as DisguiseDto.DynamicDocumentFieldTypeTextDtoV2,
                label: '',
                value: ''
              };
              break;
            }
            case 'DynamicDocumentFieldTypeCheckboxDtoV2': {
              castedFieldType = {
                ...currentColumn.fieldType as DisguiseDto.DynamicDocumentFieldTypeCheckboxDtoV2,
                label: '',
                value: false
              };
              break;
            }
          }
        }
        if (castedFieldType) {
          cells.push({
            '@type': 'DynamicDocumentListTableSectionRowCellDtoV2',
            'rows': [{
              '@type': 'DynamicDocumentRowDtoV2',
              'fields': [{
                '@type': 'DynamicDocumentFieldDtoV2',
                'fieldType': castedFieldType
              }]
            }]
          });
        }
      }
    }

    if (!section.rows) {
      section.rows = [];
    }
    section.rows.push({
      '@type': 'DynamicDocumentListTableSectionRowDtoV2',
      cells
    });
  }

  addField(content: DisguiseDto.DynamicDocumentFieldTypeDtoV2, title: string) {
    if (this.fieldConfig) {
      this.contentDialog = {
        content,
        buttons: [{
          text: 'Abbrechen',
          title: 'Abbrechen',
          onClick: () => {
            this.showContentDialog = false;
            this.contentDialog = {};
          },
          disabled: false,
          loading: false
        }, {
          text: 'Übernehmen',
          title: 'Übernehmen',
          onClick: (event: Event,
                    button: ContentDialogButton<DisguiseDto.DynamicDocumentFieldTypeTextDtoV2>,
                    fieldContent: DisguiseDto.DynamicDocumentFieldTypeTextDtoV2) => { // todo check
            if (this.fieldConfig) {
              const castedFieldType = this.fieldConfig.fieldType as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2;
              if (!castedFieldType.columns) {
                castedFieldType.columns = [];
              }
              if (castedFieldType.sections) {
                for (const currentExistingSection of castedFieldType.sections) {
                  if (!currentExistingSection.rows) {
                    currentExistingSection.rows = [];
                  }
                  for (const currentExistingSectionRow of currentExistingSection.rows) {
                    if (!currentExistingSectionRow.cells) {
                      currentExistingSectionRow.cells = [];
                    }
                    currentExistingSectionRow.cells.push({
                      '@type': 'DynamicDocumentListTableSectionRowCellDtoV2',
                      'rows': [{
                        '@type': 'DynamicDocumentRowDtoV2',
                        'fields': [{
                          '@type': 'DynamicDocumentFieldDtoV2',
                          'fieldType': {
                            ...fieldContent,
                            label: '',
                            value: ''
                          }
                        }]
                      }]
                    });
                  }
                }
              }
              castedFieldType.columns.push({
                '@type': 'DynamicDocumentListTableColumnDtoV2',
                'fieldType': fieldContent,
                'widthPercentage': ''
              });
              this.showContentDialog = false;
              this.contentDialog = {};
            }
          },
          disabled: false,
          loading: false
        }],
        onClose: () => {
          this.showContentDialog = false;
          this.contentDialog = {};
        },
        title
      };
      this.showContentDialog = true;
    }
  }

  addTextField() {
    this.addField(
      {
        '@type': 'DynamicDocumentFieldTypeTextDtoV2'
      },
      'Textbaustein erstellen'
    );
  }

  addNumberField() {
    this.addField(
      {
        '@type': 'DynamicDocumentFieldTypeNumberDtoV2'
      },
      'Zahlenbaustein erstellen'
    );
  }

  addCheckboxField() {
    this.addField(
      {
        '@type': 'DynamicDocumentFieldTypeCheckboxDtoV2'
      },
      'Checkbox erstellen'
    );
  }

  addDateField() {
    this.addField(
      {
        '@type': 'DynamicDocumentFieldTypeDateDtoV2'
      },
      'Datumbaustein erstellen'
    );
  }

  addMonthField() {
    this.addField(
      {
        '@type': 'DynamicDocumentFieldTypeYearMonthDtoV2'
      },
      'Monatbaustein erstellen'
    );
  }

  addSignatureField() {
    this.addField(
      {
        '@type': 'DynamicDocumentFieldTypeSignatureDtoV2'
      },
      'Unterschriftbaustein erstellen'
    );
  }

  onUpdateColumn(event: any) {
    const newIndex = event.newIndex || 0;
    const oldIndex = event.oldIndex || 0;

    if (this.fieldConfig
      && this.fieldConfig.fieldType
      && this.fieldConfig.fieldType['@type'] === 'DynamicDocumentFieldTypeListTableDtoV2'
    ) {
      const clonedFieldType = cloneDeep(
        this.fieldConfig.fieldType
      );
      for (const currentSection of clonedFieldType.sections || []) {
        for (const currentSectionRow of currentSection.rows || []) {
          if (currentSectionRow.cells && currentSectionRow.cells[newIndex] && currentSectionRow.cells[oldIndex]) {
            const rowAtNewIndex = currentSectionRow.cells[newIndex];
            const rowAtOldIndex = currentSectionRow.cells[oldIndex];
            currentSectionRow.cells[newIndex] = rowAtOldIndex;
            currentSectionRow.cells[oldIndex] = rowAtNewIndex;
          }
        }
      }
      this.fieldConfig.fieldType = clonedFieldType;
    }
  }

  removeColumn(columnItem: DisguiseDto.DynamicDocumentListTableColumnDtoV2) {
    this.confirmationDialogConfig = {
      title: 'Löschen Bestätigen',
      message: 'Durch das Löschen werden alle Spalteninhalte gelöscht. Wollen Sie wirklich diese Spalte löschen?',
      onEsc: () => {
        this.showConfirmationDialog = false;
      },
      headerColor: 'primary', buttons: [{
        title: 'Abbrechen',
        text: 'Abbrechen',
        loading: false,
        disabled: false,
        onClick: () => {
          this.showConfirmationDialog = false;
        }
      }, {
        title: 'Bestätigen',
        text: 'Bestätigen',
        loading: false,
        disabled: false,
        autoFocus: true,
        onClick: () => {
          if (this.fieldConfig
            && this.fieldConfig.fieldType
            && this.fieldConfig.fieldType['@type'] === 'DynamicDocumentFieldTypeListTableDtoV2'
          ) {
            const castedFieldType = this.fieldConfig.fieldType as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2;
            const clonedFieldType = cloneDeep(castedFieldType);
            if (clonedFieldType.columns) {
              const columnIndex = (castedFieldType.columns || []).indexOf(columnItem);
              if (columnIndex >= 0) {
                for (const currentSection of clonedFieldType.sections || []) {
                  for (const currentSectionRow of currentSection.rows || []) {
                    if (currentSectionRow.cells && currentSectionRow.cells[columnIndex]) {
                      currentSectionRow.cells.splice(columnIndex, 1);
                    }
                  }
                }
                clonedFieldType.columns.splice(columnIndex, 1);
                this.fieldConfig.fieldType = clonedFieldType;
              }
            }
          }
          this.showConfirmationDialog = false;
        }
      }]
    };
    this.showConfirmationDialog = true;
  }

  editColumn(columnItem: DisguiseDto.DynamicDocumentListTableColumnDtoV2) {
    if (this.fieldConfig) {
      this.contentDialog = {
        content: cloneDeep(columnItem.fieldType),
        buttons: [{
          text: 'Abbrechen',
          title: 'Abbrechen',
          onClick: () => {
            this.showContentDialog = false;
            this.contentDialog = {};
          },
          disabled: false,
          loading: false
        }, {
          text: 'Übernehmen',
          title: 'Übernehmen',
          onClick: (event: Event,
                    button: ContentDialogButton<DisguiseDto.DynamicDocumentFieldTypeTextDtoV2>,
                    fieldContent: DisguiseDto.DynamicDocumentFieldTypeTextDtoV2) => {
            if (this.fieldConfig) {
              const castedFieldType = this.fieldConfig.fieldType as DisguiseDto.DynamicDocumentFieldTypeListTableDtoV2;
              if (castedFieldType.columns) {
                const columnIndex = (castedFieldType.columns || []).indexOf(columnItem);
                if (columnIndex >= 0) {
                  castedFieldType.columns[columnIndex].fieldType = fieldContent;
                }
              }
            }
            this.showContentDialog = false;
            this.contentDialog = {};
          },
          disabled: false,
          loading: false
        }],
        onClose: () => {
          this.showContentDialog = false;
          this.contentDialog = {};
        },
        title: 'Spalte bearbeiten'
      };
      this.showContentDialog = true;
    }
  }

  removeRow(sectionRow: DisguiseDto.DynamicDocumentListTableSectionRowDto,
            section: DisguiseDto.DynamicDocumentListTableSectionDto) {
    const sectionRowIndex = (section.rows || []).indexOf(sectionRow);
    if (sectionRowIndex >= 0) {
      section.rows?.splice(sectionRowIndex, 1);
    }
  }

  removeSection(
    sections: DisguiseDto.DynamicDocumentListTableSectionDto[],
    sectionRow: DisguiseDto.DynamicDocumentListTableSectionRowDto
  ) {
    const sectionIndex = (sections).indexOf(sectionRow);
    if (sectionIndex >= 0) {
      sections?.splice(sectionIndex, 1);
    }
  }

  getHumanReadableColumnType(type: DisguiseDto.DynamicDocumentFieldTypeDtoV2) {
    let result = 'Unbekannt';
    switch (type['@type']) {
      case 'DynamicDocumentFieldTypeCheckboxDtoV2': {
        result = 'Checkbox';
        break;
      }
      case 'DynamicDocumentFieldTypeDateDtoV2': {
        result = 'Datum';
        break;
      }
      case 'DynamicDocumentFieldTypeNumberDtoV2': {
        result = 'Zahl';
        break;
      }
      case 'DynamicDocumentFieldTypeTextDtoV2': {
        result = 'Text';
        break;
      }
      case 'DynamicDocumentFieldTypeYearMonthDtoV2': {
        result = 'Monat';
        break;
      }
      case 'DynamicDocumentFieldTypeSignatureDtoV2': {
        result = 'Unterschrift';
        break;
      }
      default: {
        break;
      }
    }
    return result;
  }

}
